module.exports = __webpack_public_path__ + "static/img/cont53 (2).6e5ad45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont53 (2).jpg
// module id = SrB/
// module chunks = 0